import ITimeZone from "../interfaces/ITimeZone";
import { ADD_TIMEZONES } from "../yoello-lib/modules/redux/actions/timezone.actions";


export type timezoneState = any[] | null;

export function timezonesReducer(state: timezoneState = null, action: { type: string, payload: ITimeZone[]; }) {
    switch (action.type) {
        case ADD_TIMEZONES:
            state = action.payload;
            return state;
        default:
            return state;
    }
}